import React, { useState } from 'react';
import { Sparkles, ChevronDown } from 'lucide-react';
import History from 'constants/history';

const MobileMenuItem = ({ item, index, dropdownState, toggleDropdown, categories, path, onOptionClick }) => {
  if (item === "AI Live demo") {
    return (
      <button
        type="button"
        key={index}
        className="bg-gradient-to-r from-red-500 via-pink-500 to-purple-600 text-[white] px-3 py-2 rounded-full font-semibold flex items-center gap-2 shadow-lg mx-auto mt-2"
        style={{ fontFamily: 'Poppins, sans-serif', fontSize: '15px' }}
      >
        <Sparkles className="w-5 h-5" fill="white" />
        AI Live demo
      </button>
    );
  }

  const hasDropdown = categories && categories.length > 0;
  const isOpen = dropdownState[item] || false;

  return (
    <div key={index}>
      <button
        type="button"
        className="w-full px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-600 flex items-center justify-between transition-colors"
        onClick={() => {
          if (!!path)
            History.navigate(path);
          else if (hasDropdown)
            toggleDropdown(item);
        }}
      >
        <span>{item}</span>
        {hasDropdown && (
          <ChevronDown
            className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          />
        )}
      </button>

      {Boolean(hasDropdown && isOpen) && (
        <div className="px-4 py-2">
          {categories.map((category, catIdx) => (
            <div key={catIdx} className="mb-4">
              {category.name && (
                <h4
                  className="font-bold text-gray-900 mb-2 text-xs"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                  onClick={() => onOptionClick(category, category.id)}
                >
                  {category.name}
                </h4>
              )}
              <ul className="space-y-2 ml-2">
                {(category.options || [category]).map((subItem, subIdx) => (
                  <li key={subIdx}>
                    <button
                      className="text-gray-500 hover:text-blue-600 text-xs text-left w-full flex items-center"
                      style={{ fontFamily: 'Poppins, sans-serif' }}
                      onClick={() => onOptionClick(subItem, category.id)}
                    >
                      {subItem.icon && <subItem.icon className="w-4 h-4 mr-2" />}
                      {subItem.text}
                      {subItem.badge && (
                        <span className="ml-2 text-blue-500 text-xs font-bold">
                          {subItem.badge}
                        </span>
                      )}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const MobileMenu = ({
  isOpen,
  menuItems,
  optionsForYourAiEmployee,
  optionsForStartups,
  optionsForAddons,
  onOptionClick
}) => {
  const [dropdownState, setDropdownState] = useState({});

  const toggleDropdown = (item) => {
    setDropdownState(prev => ({
      ...prev,
      [item]: !prev[item]
    }));
  };

  const getCategoriesForItem = (item) => {
    switch (item) {
      case "YOUR AI EMPLOYEES":
        return optionsForYourAiEmployee;
      case "FOR STARTUPS":
        return optionsForStartups;
      case "ADD ONS":
        return optionsForAddons;
      default:
        return null;
    }
  };

  if (!isOpen) return null;

  return (
    <div className="hidden md:block pb-4 border-t border-gray-200">
      {menuItems?.map((item, index) => (
        <MobileMenuItem
          key={index}
          item={item.name}
          path={item.path}
          index={index}
          dropdownState={dropdownState}
          toggleDropdown={toggleDropdown}
          categories={getCategoriesForItem(item.name)}
          onOptionClick={onOptionClick}
        />
      ))}
    </div>
  );
};

export default MobileMenu;